import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/word");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto py-12" data-testid="login-page">
      <div className="text-xs uppercase tracking-[0.3em] text-[#78350F] mb-4">Sign in</div>
      <h1 className="font-serif-display text-4xl text-stone-900 mb-10">Return to your studies.</h1>
      <form onSubmit={submit} className="space-y-8">
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-stone-500 mb-2">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
            className="w-full bg-transparent border-b border-stone-300 focus:border-[#9A3B3B] focus:outline-none px-0 py-2 text-lg" />
        </div>
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-stone-500 mb-2">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
            className="w-full bg-transparent border-b border-stone-300 focus:border-[#9A3B3B] focus:outline-none px-0 py-2 text-lg" />
        </div>
        <button type="submit" disabled={busy} data-testid="login-submit"
          className="bg-[#9A3B3B] hover:bg-[#7F2F2F] text-white px-8 py-3 tracking-wide transition-colors disabled:opacity-60">
          {busy ? "Signing in..." : "Sign in"}
        </button>
      </form>
      <div className="mt-8 text-sm text-stone-600">
        New here? <Link to="/register" className="text-[#9A3B3B] underline underline-offset-4" data-testid="to-register">Create an account</Link>
      </div>
    </div>
  );
}
